import { Grade9CourseOverviewData } from "../../data/OSSDOverviewData/Grade9CourseOverviewData";
import Grade from "../../components/CourseComp/Grade";

export default function GradeNineOverviewPage() {
    return (
        <div>
            <Grade data={Grade9CourseOverviewData} />
        </div>
    )
}